module.exports = __webpack_public_path__ + "img/sweeden-flag.ed8cd681.svg";